var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSortWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-sort_amount_up_reversed",
    d: "M6.667,6a.667.667,0,1,0,0,1.333h1A.667.667,0,1,0,7.667,6ZM14.99,6a.667.667,0,0,0-.462.2L12.2,8.528a.667.667,0,1,0,.943.943l1.2-1.2v6.391a.667.667,0,1,0,1.333,0V8.276l1.2,1.2a.667.667,0,1,0,.943-.943L15.471,6.2A.667.667,0,0,0,14.99,6ZM6.667,8.666a.667.667,0,1,0,0,1.333H9A.667.667,0,1,0,9,8.666Zm0,2.667a.667.667,0,1,0,0,1.333h3.667a.667.667,0,1,0,0-1.333Zm0,2.667a.667.667,0,1,0,0,1.333h5a.667.667,0,1,0,0-1.333Zm0,2.667a.667.667,0,1,0,0,1.333H13a.667.667,0,1,0,0-1.333Z",
    transform: "translate(-6 -6)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSortWhite);
export default __webpack_public_path__ + "static/media/iconSortWhite.1198790ca44e0367ff11b905e3a464c4.svg";
export { ForwardRef as ReactComponent };